// extracted by mini-css-extract-plugin
export default {"searchReturnList":"SearchReturnList_searchReturnList__ishwY","searchReturnItem":"SearchReturnList_searchReturnItem__lvctu"};